import { ReactElement, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import getUserData from 'utils/api/getUserData';
import { USER_PROFILE, MAIN } from 'constants/pathNames';

const UserProfilePage = (): ReactElement => {
  const navigate = useNavigate();

  useEffect(() => {
    getUserData(USER_PROFILE)
      .then((response) => console.log('response: ', response))
      .catch((error) => {
        if (error.status === 401) {
          navigate(MAIN);
        }
      });
  }, []);

  return (
    <div className="container">
      <h2 className="title"><FormattedMessage id="user.profile.title" values={{ name: 'Test' }} /></h2>
    </div>
  );
};

export default UserProfilePage;
